import { createAction } from 'redux-actions';

export const onValidRecaptcha = createAction('RECAPTCHA/VALID_RECAPTCHA', token => token);
export const onExpiredReCapture = createAction('RECAPTCHA/EXPIRED_RECAPTCHA');
export const requestRecaptureUpdate = createAction('RECAPTCHA/REQUEST_UPDATE');
export const updateRecapture = createAction('RECAPTCHA/UPDATE');
export const resetRecaptureState = createAction('RECAPTCHA/RESET');
